<nav class="navbar">
  <div class="navbar-container">

    <div class="navbar-logo">
      <img class="logo" src="assets/img/logo.png" alt="">
    </div>

    <ul class="navbar-links" [class.open]="menuAberto">
      <li><a routerLink="/home" (click)="menuAberto = false">Home</a></li>
      <li><a routerLink="/solucao" (click)="menuAberto = false">Solução</a></li>
      <li><a routerLink="/conteudos" (click)="menuAberto = false">Conteúdos</a></li>
      <li><a href="https://academy.mistercontador.com.br/academy-intro" target="_blank" rel="noopener noreferrer" (click)="menuAberto = false; true">Mister Academy</a></li>
      <li class="nav-dropdown-wrap">
        <a href="#" (click)="toggleAtendimento($event)">Atendimento</a>

        <div class="atendimento-dropdown" *ngIf="atendimentoAberto">

          <div class="atend-group">
            <span class="atend-label">Ainda não sou cliente</span>
            <a href="https://api.whatsapp.com/send/?phone=5548991707731" target="_blank" rel="noopener noreferrer" class="atend-item">
              <div class="atend-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#29b6f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
              </div>
              <span>Adquira Mister por Whatsapp</span>
            </a>
          </div>

          <div class="atend-divider"></div>

          <div class="atend-group">
            <span class="atend-label">Já sou cliente</span>
            <a href="https://tawk.to/chat/615d935225797d7a890299f9/1hlda7fs2" class="atend-item">
              <div class="atend-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#29b6f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              </div>
              <span>Suporte Técnico por Chat</span>
            </a>
            <a href="https://api.whatsapp.com/send/?phone=5548991546310" class="atend-item">
              <div class="atend-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#29b6f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
              </div>
              <span>Suporte Financeiro por Whatsapp</span>
            </a>
            <a href="https://mistercontador.framer.wiki/" class="atend-item">
              <div class="atend-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#29b6f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="10" r="3"></circle><path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"></path></svg>
              </div>
              <span>Central de Ajudas Mister</span>
            </a>
            <a href="https://api.whatsapp.com/send/?phone=5548991707731" class="atend-item">
              <div class="atend-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#29b6f6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
              </div>
              <span>Adquirir novo produto por Whatsapp</span>
            </a>
          </div>

        </div>
      </li>
      <li class="mobile-only"><a href="https://app.mistercontador.com.br/login" (click)="menuAberto = false">Entrar</a></li>
      <li class="mobile-only"><a href="https://mistercontadorforms.bitrix24.site/crm_form_azjjm/" class="btn-conheca" (click)="menuAberto = false">Conheça</a></li>
    </ul>

    <div class="navbar-actions">
      <a href="https://app.mistercontador.com.br/login" class="btn-entrar">Entrar</a>
      <a href="https://mistercontadorforms.bitrix24.site/crm_form_azjjm/" class="btn-conheca">Conheça</a>
    </div>

    <button class="menu-toggle" (click)="menuAberto = !menuAberto">
      <span></span>
      <span></span>
      <span></span>
    </button>

  </div>
</nav>
